import React from 'react';
import {useNavigate} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';
import {useLanguage} from '../context/LanguageContext';

const {FiArrowRight} = FiIcons;

export default function BarCard({bar, index}) {
  const navigate = useNavigate();
  const {t, lang} = useLanguage();
  const translatedCategory = lang === 'es' ? bar.category_es : bar.category_en;
  const translatedDescription = lang === 'es'
    ? bar.description_es
    : bar.description_en;

  return (
    <motion.div
      initial={{opacity: 0, scale: 0.98, y: 40}}
      whileInView={{opacity: 1, scale: 1, y: 0}}
      viewport={{once: true, margin: '-100px'}}
      transition={{duration: 0.9, delay: index * 0.15, ease: [0.23, 1, 0.32, 1]}}
      className="group relative flex flex-col md:flex-row gap-8 lg:gap-16 items-center bg-zinc-900/40 border border-zinc-800/40 rounded-[2.5rem] p-6 md:p-10 hover:bg-zinc-900/60 hover:border-zinc-700/60 hover:shadow-[0_0_60px_-15px_rgba(255,255,255,0.08)] transition-all duration-700"
    >
      <div className="absolute -inset-1 bg-gradient-to-r from-zinc-500/0 via-zinc-400/5 to-zinc-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-1000 rounded-[2.5rem]" />

      <div className="w-full md:w-[45%] aspect-[16/10] md:aspect-[4/5] lg:aspect-[4/3] overflow-hidden rounded-3xl bg-zinc-950 relative z-10 shadow-2xl">
        <div className="absolute inset-0 bg-zinc-950/20 group-hover:bg-transparent transition-colors duration-1000 z-10" />
        <img
          src={bar.image}
          alt={`${bar.name} in Barberà del Vallès`}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[2s] ease-out"
          loading="lazy"
        />
      </div>

      <div className="w-full md:w-[55%] flex flex-col justify-center py-4 relative z-10">
        <div className="flex items-center gap-4 mb-6">
          <motion.div
            initial={{width: 24}}
            whileInView={{width: 40}}
            className="h-px bg-zinc-600 group-hover:bg-zinc-400 transition-all duration-700"
          />
          <span className="text-[11px] font-bold tracking-[0.4em] text-zinc-500 group-hover:text-zinc-300 uppercase transition-colors duration-500">
            {translatedCategory}
          </span>
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-zinc-50 mb-6 tracking-tight group-hover:text-white transition-colors duration-500 leading-tight">
          {bar.name}
        </h2>

        <p className="text-zinc-400 leading-relaxed mb-12 font-light text-lg md:text-xl max-w-prose">
          {translatedDescription}
        </p>

        <button
          onClick={() => navigate(`/menu/${bar.id}`)}
          className="inline-flex items-center gap-4 text-[11px] font-bold tracking-[0.25em] uppercase text-zinc-950 bg-zinc-50 hover:bg-white px-10 py-5 rounded-2xl w-fit transition-all duration-500 group/btn shadow-2xl shadow-black/50 hover:-translate-y-1 active:translate-y-0"
        >
          {t.ui.viewMenu}
          <SafeIcon icon={FiArrowRight} className="text-xl transition-transform duration-500 group-hover/btn:translate-x-2" />
        </button>
      </div>
    </motion.div>
  );
}